import { isBefore, subMonths } from 'date-fns'

import { DEFAULT_DATE_RANGE } from '../CommunityFilters/types'
import type { DateRange } from '../CommunityFilters/types'

/** Comments published before this many months ago are not retained. */
export const RETENTION_WINDOW_MONTHS = 12

export const RETENTION_WINDOW_LABEL = `${RETENTION_WINDOW_MONTHS} months`

export const RETENTION_COUNT_SUFFIX = `(last ${RETENTION_WINDOW_LABEL})`

export const RETENTION_NOTICE_TEXT = `Showing comments from the past ${RETENTION_WINDOW_LABEL}.`

export const isRetentionWindowActive = (
  publishedAt: DateRange | undefined,
): boolean => (publishedAt ?? DEFAULT_DATE_RANGE) === DEFAULT_DATE_RANGE

export const isOlderThanRetentionWindow = (
  publishedAt: string | null | undefined,
  now: Date = new Date(),
): boolean => {
  if (!publishedAt) {
    return false
  }
  const published = new Date(publishedAt)
  if (Number.isNaN(published.getTime())) {
    return false
  }
  return isBefore(published, subMonths(now, RETENTION_WINDOW_MONTHS))
}
